<script lang="typescript">
  import * as cgtypes from "chessground/types";
  export let role: cgtypes.Role;
  export let color: cgtypes.Color;
</script>

<span class="h-full w-full bg-cover inline-block cg-piece {role} {color}"></span>
